import TrackingHistoryInfo from './TrackingHistoryInfo';

export default TrackingHistoryInfo;



// WEBPACK FOOTER //
// ./src/components/atoms/TrackingHistoryInfo/index.js